import { render, staticRenderFns } from "./CVColorAlertMessage.vue?vue&type=template&id=525fe8a8"
import script from "./CVColorAlertMessage.vue?vue&type=script&lang=js"
export * from "./CVColorAlertMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports